import React from "react";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <nav
      style={{
        display: "flex",
        height: "inherit",
        fontSize: "2em",
        fontWeight: "bold",
        paddingLeft: "16px",
        alignItems: "center",
        textTransform: "lowercase",
      }}
    >
      <ul style={{ width: "100%" }}>
        <li>
          <Link style={{ display: "block" }} to="/sellers">
            Sellers
          </Link>
        </li>
        <li>
          <Link style={{ display: "block" }} to="/products">
            Products
          </Link>
        </li>
        <li>
          <Link style={{ display: "block" }} to="/articles">
            Articles
          </Link>
        </li>
        <li>
          <Link style={{ display: "block" }} to="/discover">
            Discover
          </Link>
        </li>
        <li>
          <Link style={{ display: "block" }} to="/notifs">
            Notifs
          </Link>
        </li>
      </ul>
    </nav>
  );
}
